import { Big } from 'big.js'
import { Measure } from '../types'


enum AreaMeasurementSystem {
  metric = 'Metric Units',
  imperial = 'Imperial Units'
}

const areaUnits = {
  square_nanometer: {
    displayName: 'Square Nanometer',
    codeName: 'square_nanometer',
    url: 'square-nanometer',
    symbol: 'nm²',
    toBaseUnit: (value: Big): Big => value.div(1000000000000000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000000000000000),
    system: AreaMeasurementSystem.metric
  },
  square_micrometer: {
    displayName: 'Square Micrometer',
    codeName: 'square_micrometer',
    url: 'square-micrometer',
    symbol: 'µm²',
    toBaseUnit: (value: Big): Big => value.div(1000000000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000000000),
    system: AreaMeasurementSystem.metric
  },
  square_millimeter: {
    displayName: 'Square Millimeter',
    codeName: 'square_millimeter',
    url: 'square-millimeter',
    symbol: 'mm²',
    toBaseUnit: (value: Big): Big => value.div(1000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000),
    system: AreaMeasurementSystem.metric
  },
  square_centimeter: {
    displayName: 'Square Centimeter',
    codeName: 'square_centimeter',
    url: 'square-centimeter',
    symbol: 'cm²',
    toBaseUnit: (value: Big): Big => value.div(10000),
    fromBaseUnit: (value: Big): Big => value.times(10000),
    system: AreaMeasurementSystem.metric
  },
  square_meter: {
    displayName: 'Square Meter',
    codeName: 'square_meter',
    url: 'square-meter',
    symbol: 'm²',
    toBaseUnit: (value: Big): Big => value,
    fromBaseUnit: (value: Big): Big => value,
    system: AreaMeasurementSystem.metric
  },
  square_kilometer: {
    displayName: 'Square Kilometer',
    codeName: 'square_kilometer',
    url: 'square-kilometer',
    symbol: 'km²',
    toBaseUnit: (value: Big): Big => value.times(1000000),
    fromBaseUnit: (value: Big): Big => value.div(1000000),
    system: AreaMeasurementSystem.metric
  },
  hectare: {
    displayName: 'Hectare',
    codeName: 'hectare',
    url: 'hectare',
    symbol: 'ha',
    toBaseUnit: (value: Big): Big => value.times(10000),
    fromBaseUnit: (value: Big): Big => value.div(10000),
    system: AreaMeasurementSystem.metric
  },

  square_inch: {
    displayName: 'Square Inch',
    codeName: 'square_inch',
    url: 'square-inch',
    symbol: 'in²',
    toBaseUnit: (value: Big): Big => value.div(1550.0031),
    fromBaseUnit: (value: Big): Big => value.times(1550.0031),
    system: AreaMeasurementSystem.imperial
  },
  square_foot: {
    displayName: 'Square Foot',
    codeName: 'square_foot',
    url: 'square-foot',
    symbol: 'ft²',
    toBaseUnit: (value: Big): Big => value.div(10.76391041671),
    fromBaseUnit: (value: Big): Big => value.times(10.76391041671),
    system: AreaMeasurementSystem.imperial
  },
  square_yard: {
    displayName: 'Square Yard',
    codeName: 'square_yard',
    url: 'square-yard',
    symbol: 'yd²',
    toBaseUnit: (value: Big): Big => value.div(1.1959900463),
    fromBaseUnit: (value: Big): Big => value.times(1.1959900463),
    system: AreaMeasurementSystem.imperial
  },
  square_mile: {
    displayName: 'Square Mile',
    codeName: 'square_mile',
    url: 'square-mile',
    symbol: 'mi²',
    toBaseUnit: (value: Big): Big => value.times(2589988.110336),
    fromBaseUnit: (value: Big): Big => value.div(2589988.110336),
    system: AreaMeasurementSystem.imperial
  },
  acre: {
    displayName: 'Acre',
    codeName: 'acre',
    url: 'acre',
    symbol: 'ac',
    toBaseUnit: (value: Big): Big => value.times(4046.8564224),
    fromBaseUnit: (value: Big): Big => value.div(4046.8564224),
    system: AreaMeasurementSystem.imperial
  }
}

export const area: Measure = {
  displayName: 'Area',
  codeName: 'area',
  url: 'area',
  units: areaUnits,
  baseUnit: areaUnits.square_meter,
  defaultFromUnit: areaUnits.square_meter,
  defaultToUnit: areaUnits.square_foot
}
